// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';
import { ReactMultiEmail } from 'react-multi-email';
import MaskedInput from 'react-text-mask';
import _ from 'lodash';
// local
// views
import SaveUpdateModal from './SaveUpdateModal';
import DropdownClient from 'app/ui/commons/DropdownClient';
import ErrorLabel from 'app/ui/commons/ErrorLabel';
// libs
import { isValidCNPJ, isValidEmail, isFormValid, isValidPhone, removeReadOnly } from 'app/lib/formHelper';
import { _val, _valSupplierEmail } from 'app/lib/helper';
import { CNPJ_MASK, PHONE_MASK } from 'app/lib/masks';
// actions
import { ACTION } from 'app/redux/actions/modal';
import { create, update } from 'app/redux/actions/supplier';
// consts
import { TYPE as CLIENT_TYPE, STATUS as CLIENT_STATUS } from 'salvus-shared/consts/client';
import { PROFILE as ACCOUNT_PROFILE } from 'salvus-shared/consts/account';
import './SupplierModal.css';

class SupplierModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: this.initForm(),
            errors: {},
        };
    }

    componentWillReceiveProps(nextProps) {
        const { isOpened: isOpenedP } = this.props.modalSaveUpdate;
        const { isOpened: isOpenedN, action: actionN, data: dataN } = nextProps.modalSaveUpdate;

        if (!isOpenedP && isOpenedN) {
            const { client, profile } = nextProps.auth.account;
            const values = actionN === ACTION.UPDATE ? dataN : {};
            if (!(client.type === CLIENT_TYPE.SALVUS && profile === ACCOUNT_PROFILE.ADMIN)) {
                values.clientId = client.id;
            }
            this.setState({ form: this.initForm(values), errors: {} });
        }
    }

    initForm(values = {}) {
        const price = values.price ? values.price.replace('.', ',') : '0,00';
        return {
            id: _val(values.id, null),
            name: _val(values.name, ''),
            emails: _valSupplierEmail(values.email),
            cnpj: _val(values.cnpj, ''),
            price,
            phone1: _val(values.phone1, ''),
            phone2: _val(values.phone2, ''),
            clientId: _val(values.clientId, null),
        };
    }

    validateForm(form, field) {
        const errors = {};

        const name = form.name;
        if (!field || field === 'name') {
            if (_.isEmpty(name)) {
                errors['name'] = 'O campo nome é obrigatório.';
            } else {
                errors['name'] = undefined;
            }
        }

        const emails = form.emails;
        if (!field || field === 'emails') {
            if (_.isEmpty(emails)) {
                errors['emails'] = 'O campo e-mail é obrigatório.';
            } else {
                for (let email of emails) {
                    if (!isValidEmail(email)) {
                        errors['emails'] = `O campo e-mail não é válido.`;
                    } else {
                        errors['emails'] = undefined;
                    }
                }
            }
        }

        const cnpj = form.cnpj;
        if (!field || field === 'cnpj') {
            if (_.isEmpty(cnpj)) {
                errors['cnpj'] = 'O campo CNPJ é obrigatório.';
            } else if (!isValidCNPJ(cnpj)) {
                errors['cnpj'] = 'O campo CNPJ não é válido.';
            } else {
                errors['cnpj'] = undefined;
            }
        }

        const price = form.price.replace(',', '.');
        if (!field || field === 'price') {
            if (price <= 0) {
                errors['price'] = 'O campo preço é obrigatório.';
            } else {
                errors['price'] = undefined;
            }
        }

        const phone1 = form.phone1;
        if (!field || field === 'phone1') {
            if (_.isEmpty(phone1)) {
                errors['phone1'] = 'O campo telefone principal é obrigatório.';
            } else if (!isValidPhone(phone1)) {
                errors['phone1'] = 'O campo telefone principal não é válido.';
            } else {
                errors['phone1'] = undefined;
            }
        }

        const phone2 = form.phone2;
        if (!field || field === 'phone2') {
            if (!_.isEmpty(phone2) && !isValidPhone(phone2)) {
                errors['phone2'] = 'O campo telefone não é válido.';
            } else {
                errors['phone2'] = undefined;
            }
        }

        const clientId = form.clientId;
        if (!field || field === 'clientId') {
            if (clientId === null) {
                errors['clientId'] = 'É obrigatório selecionar o cliente.';
            } else {
                errors['clientId'] = undefined;
            }
        }

        return errors;
    }

    onChange = field => (e, target) => {
        const { value } = target || e.target;
        let { form, errors } = this.state;
        _.set(form, field, value);
        const validation = this.validateForm(form, field);
        _.forIn(validation, function(value, key) {
            errors[key] = value;
        });
        this.setState({ form, errors });
    };

    onChangeEmail = _emails => {
        const field = 'emails';
        const value = _emails;
        let { form, errors } = this.state;
        _.set(form, field, value);
        const validation = this.validateForm(form, field);
        _.forIn(validation, function(value, key) {
            errors[key] = value;
        });
        this.setState({ form, errors });
    };

    onChangePrice = field => (e, target) => {
        const key = e.key;
        let { form, errors } = this.state;
        let { value } = target || e.target;
        value = value
            .split('$')[1]
            .trim()
            .replace(',', '.');

        if (value.length > 9 && key !== 'Backspace') {
            return;
        }

        const val = parseInt(e.key, 10);
        if (isNaN(val) && key !== 'Backspace') {
            value = value.replace('.', ',');
            _.set(form, field, value);
            const validation = this.validateForm(form, field);
            _.forIn(validation, function(value, key) {
                errors[key] = value;
            });
            this.setState({ form, errors });
            return;
        }

        if (key === 'Backspace') {
            value /= 10;
            value = value.toFixed(3);
            value = value.substr(0, value.length - 1);
        } else {
            value = parseFloat(value);
            value *= 10;
            value += val / 100;
            value = value.toFixed(2);
        }
        value = value.replace('.', ',');
        _.set(form, field, value);
        const validation = this.validateForm(form, field);
        _.forIn(validation, function(value, key) {
            errors[key] = value;
        });
        this.setState({ form, errors });
    };

    hasError = field => !_.isEmpty(this.state.errors[field]);

    onConfirmModal = () => {
        // check if there is any error in the form
        const errors = this.validateForm(this.state.form);
        if (!isFormValid(errors)) {
            this.setState({ errors });
            // return false to not close the popup
            return false;
        }
        // if there are not errors, submit to the backend
        const { form } = this.state;
        const { action } = this.props.modalSaveUpdate;
        if (action === ACTION.ADD) {
            this.props.dispatch(create(form));
        } else if (action === ACTION.UPDATE) {
            this.props.dispatch(update(form.id, form));
        }
        // return false to not close the popup
        return false;
    };

    render() {
        // props
        const { dispatch, modalSaveUpdate, auth } = this.props;
        const options = {
            dispatch,
            title: 'Fornecedor',
            onConfirmModal: this.onConfirmModal,
            action: modalSaveUpdate.action,
            isOpened: modalSaveUpdate.isOpened,
            loading: modalSaveUpdate.loading,
            error: modalSaveUpdate.error,
        };
        // state
        const { form, errors } = this.state;
        const { emails } = form;
        return (
            <SaveUpdateModal id="supplierModal" options={options}>
                <Form>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Nome" error={errors['name']} />}
                            placeholder="Nome"
                            type="text"
                            width={16}
                            value={form.name}
                            onChange={this.onChange('name')}
                            error={this.hasError('name')}
                            maxLength="80"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                    <div style={{ display: 'block !important', width: '100% !important', color: 'black', paddingBottom: '2px', fontWeight: 'bold' }}>
                        <ErrorLabel label="E-mail" error={errors['email']} />
                    </div>
                    <Form.Group>
                        <ReactMultiEmail
                            onChange={_emails => {
                                this.onChangeEmail(_emails);
                            }}
                            error={this.hasError('emails')}
                            placeholder="E-mail"
                            emails={emails}
                            style={{ width: '100%' }}
                            getLabel={(email, index, removeEmail) => {
                                return (
                                    <div data-tag key={index}>
                                        {email}
                                        <span data-tag-handle onClick={() => removeEmail(index)}>
                                            ×
                                        </span>
                                    </div>
                                );
                            }}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="CNPJ" error={errors['cnpj']} />}
                            control={MaskedInput}
                            mask={CNPJ_MASK}
                            guide
                            placeholder="CNPJ"
                            type="text"
                            width={8}
                            value={form.cnpj}
                            onChange={this.onChange('cnpj')}
                            error={this.hasError('cnpj')}
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <Form.Input
                            label={<ErrorLabel label="Preço m³" error={errors['price']} />}
                            placeholder="Preço m³"
                            type="text"
                            width={8}
                            value={'R$ ' + form.price}
                            onKeyDown={this.onChangePrice('price')}
                            error={this.hasError('price')}
                            maxLength="9"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Fone Principal" error={errors['phone1']} />}
                            control={MaskedInput}
                            mask={PHONE_MASK}
                            guide
                            placeholder="Fone Principal"
                            type="text"
                            width={8}
                            value={form.phone1}
                            onChange={this.onChange('phone1')}
                            error={this.hasError('phone1')}
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <Form.Input
                            label={<ErrorLabel label="Fone Extra" error={errors['phone2']} optional />}
                            control={MaskedInput}
                            mask={PHONE_MASK}
                            guide
                            placeholder="Fone Extra"
                            type="text"
                            width={8}
                            value={form.phone2}
                            onChange={this.onChange('phone2')}
                            error={this.hasError('phone2')}
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                    {auth.account.client.type === CLIENT_TYPE.SALVUS && auth.account.profile === ACCOUNT_PROFILE.ADMIN && (
                        <Form.Group>
                            <DropdownClient
                                width={16}
                                value={form.clientId}
                                onChange={this.onChange('clientId')}
                                filter={[CLIENT_STATUS.NEW, CLIENT_STATUS.ENABLED]}
                                error={errors['clientId']}
                            />
                        </Form.Group>
                    )}
                </Form>
            </SaveUpdateModal>
        );
    }
}

SupplierModal.propTypes = {
    modalSaveUpdate: PropTypes.object,
    auth: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
    modalSaveUpdate: state.modalSaveUpdate,
});
export default connect(mapStateToProps)(SupplierModal);
